import React from "react";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import { StdGrid, StdToolbar, ContentBlock, createGridOptions, stdReadOnlyGridOptions } from "../../components";
import { predefinedLabelStore } from "../../api";
import { dataSources, enums } from "../../base";
import AuthorizedComponent from "../authorized-component";
import { PredefinedLabelModel } from "../../models";

export default class PredefinedLabelPage extends AuthorizedComponent {
    objectName = "PredefinedLabel";
    moduleName = "PredefinedLabel";
    gridRef = React.createRef<DataGrid>();
    toolbarRef = React.createRef<StdToolbar>();
    gridOptions = createGridOptions("predefinedLabels", this.gridRef, stdReadOnlyGridOptions);

    columns: IColumnProps[] = [
        {
            dataField: 'dataType',
            lookup: { dataSource: dataSources.labelDataTypes, displayExpr: 'text', valueExpr: 'value' }
        },
        { dataField: 'labelText' },
        { dataField: 'groupName' }
    ];

    constructor(props: Readonly<any>) {
        super(props);

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = e => this.onButtonClick(e.data, "edit");
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.toolbarRef.current?.setModel(e.selectedRowsData[0]);
        } else {
            this.toolbarRef.current?.setModel({});
        }
    }

    onButtonClick(model: PredefinedLabelModel, name: string) {
        const grid = this.gridRef.current?.instance;

        if (grid) {
            switch (name) {
                case "add":
                    if (this.permissions[enums.stdActions.create]) {
                        grid.addRow();
                    }
                    break;

                case "edit":
                    if (this.permissions[enums.stdActions.update]) {
                        grid.editRow(grid.getRowIndexByKey(model.id));
                    }
                    break;

                case "delete":
                    if (this.permissions[enums.stdActions.delete]) {
                        grid.deleteRow(grid.getRowIndexByKey(model.id));
                    }
                    break;
            }
        }
    }

    render() {
        return (
            <ContentBlock caption={"预定义标签"}>
                <StdToolbar 
                    permissions={this.permissions}
                    ref={this.toolbarRef} 
                    onButtonClick={this.onButtonClick} />
                <StdGrid
                    moduleName={this.moduleName}
                    gridRef={this.gridRef}
                    dataSource={predefinedLabelStore}
                    options={this.gridOptions}
                    columns={this.columns}
                    popupWidth={400}
                    popupHeight={280}
                    formColCount={1} />
            </ContentBlock>
        );
    }
}